// Whether the timeline draws the Delta cost-down projects in their own lane
// or inside the Delta team lane. One lane is the default (2026-10-05 admin
// feedback: "Delta Team and Delta Projects ... should just be one thing");
// the split is an opt-in that this browser remembers. Storage is guarded the
// same way as the intro flag: blocked storage just means the default.

import { storage, type StorageLike } from './roadmapIntro';
import type { DeltaLaneMode } from './roadmapTimelineUtils';

export const DELTA_LANE_KEY = 'roadmap.timeline.deltaLane';
export const DEFAULT_DELTA_LANE: DeltaLaneMode = 'team';

/** The remembered choice; the default when nothing valid is stored or storage is unavailable. */
export function readDeltaLane(store: StorageLike | null = storage()): DeltaLaneMode {
  try {
    const raw = store?.getItem(DELTA_LANE_KEY);
    return raw === 'own' || raw === 'team' ? raw : DEFAULT_DELTA_LANE;
  } catch {
    return DEFAULT_DELTA_LANE;
  }
}

export function saveDeltaLane(mode: DeltaLaneMode, store: StorageLike | null = storage()): void {
  try {
    store?.setItem(DELTA_LANE_KEY, mode);
  } catch {
    // storage blocked: the choice lasts for this visit only
  }
}
